/*
 * @Description: 自定义推广详情（多店）
 * @Author: kayvor
 * @Date: 2020-10-16 16:48:27
 * @LastEditors: kayvor
 * @LastEditTime: 2021-02-19 17:03:13
 */
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import InfiniteLoading from 'vue-infinite-loading'
import guideFloating from '@/components/guideFloating/guideFloating.vue'
import {
    Header,
    Banner,
    Map,
    Title,
    GoodsSwiper,
    GoodsList
} from '@/components/customPromotion'
import { wxShare } from '@/utils/wxsdk'
import {
    getPromotionInfo,
    getPromotionGoodsInfo,
    getPromotionFloorInfo,
} from '@/models/custom'
import { queryKey } from '@/utils/util'
import {
    setLocalConfig,
    getLocalConfig
} from '@/utils/storage.js'
import _ from 'lodash'
import { Dialog } from 'vant'
import { isIOS, isAndroid } from '@/utils/ua'

export default {
    name: viewName.customDetail,
    inject: ['showLoading', 'hideLoading'],
    components: {
        InfiniteLoading,
        Header,
        Banner,
        Map,
        Title,
        GoodsSwiper,
        GoodsList,
        guideFloating,
        [Dialog.name]: Dialog,
    },
    data () {
        return {
            detailParams: {
                topic_id: '', // 推广id
                store_id: '', // 商家id
            },
            page_size: 12,
            page_no: 1,
            pageSize: 2,
            pageNo: 1,
            pageStatus: true,
            // 单店返回，多店返回空
            sstore: {
                sstore_name: '', // 门店名称
                sstore_address: '', // 门店地址
                distance: '', // 距离
            },
            page_bg_color: '', // 页面背景颜色
            banner: {
                url: '', // 头图
                title: '', // 大标名称
                title_size: '', // 大标字体大小
                title_family: '', // 大标字体
                title_color: '', // 大标字体颜色
                sub_title: '', // 小标名称
                sub_title_size: '', // 小标字体大小
                sub_title_family: '', // 小标字体
                sub_title_color: '', // 小标字体颜色
            },
            floor: {
                floor_title: '', // 主推楼层名称
                floor_title_bg_img: '', // 主推楼层名称底图
                floor_goods_title: '', // 商品楼层名称
                floor_goods__bg_img: '', // 商品楼层名称底图
                floor_goods: [
                    // {
                    //     spu_id: '', // 商品规格id
                    //     goods_id: '', // 商品id
                    //     goods_img: '', // 商品图片
                    //     goods_name: '', // 商品名称
                    //     goods_price: '', // 商品原价
                    //     goods_present_price: '', // 商品现价
                    //     goods_sell_out: 1 || 0, // 是否已售罄, 0: 未售罄, 1： 已售罄
                    // },
                ]
            },
            share: {
                title: '', // 分享标题
                desc: '', // 分享描述
                imgUrl: '', // 分享图片
            },
            goodsList: [
                // {
                //     spu_id: '', // 商品规格id
                //     goods_id: '', // 商品id
                //     goods_img: '', // 商品图片
                //     goods_name: '', // 商品名称
                //     goods_price: '', // 商品原价
                //     goods_present_price: '', // 商品现价
                //     goods_sell_out: 1 || 0, // 是否已售罄, 0: 未售罄, 1： 已售罄
                // }
            ],
            floatBtnList: [{key: 'feedback', top: '68'}, {key: 'top', top: '76.5'}],
            position: {
                longitude: '',
                latitude: ''
            },
            isPosition: false,
            address: '',
            count: 7,
            // 商品楼层，不传is_specially_activity或者is_specially_activity=0，才返回，否则为空数组
            floor_infos: [
                // {
                //     floor_id: '1', // 楼层id
                //     floor_name: '1', // 楼层名称
                //     floor_bg_img: '',    // 楼层背景图片
                //     shop_info: [ // 超出6个显示更多，后端最多返回7个商品
                //         {
                //             goods_id: '12',    // goods_id（自增id）
                //             spu_id: '商品id',
                //             goods_img: 'xxx',
                //             goods_name: '商品名称',
                //             goods_price: '', // 商品原价不，参与活动的商品原价返回空
                //             goods_present_price: '现价',
                //             goods_sell_out:  0, // 是否已售罄, 0: 未售罄, 1： 已售罄
                //             goods_type: 'agent', // agent代理
                //         },
                //     ]
                // },
            ],
            params: {}
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({
                appInfo
            }) => appInfo.isWeixin,
            icarAppInfo: ({ appInfo }) => appInfo.icarAppInfo
        }),
        isApp () {
            return this.icarAppInfo.app_name === 'iCar_app'
        }
    },
    watch: {
        isPosition (newValue) {
            if (newValue) {
                if (!this.address) {
                    this.getAddressData()
                }
            }
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            Object.assign(vm.detailParams, to.query)
            vm.page_bg_color && vm.doBgColor()
        })
    },
    created () {
    },
    activated () {
        const status = getLocalConfig('isChangePosition')
        if (status === '1' && this.pageStatus) {
            this.initLocation()
            setLocalConfig('isChangePosition', '0')
        }
    },
    deactivated () {
        this.doBgColor('del')
    },
    mounted () {
        document.body.scrollIntoView()
        Object.assign(this.detailParams, this.$route.query)
        if (queryKey(this.detailParams, ['topic_id'])) {
            this.initLocation()
            this.getPromotionData()
        } else {
            this.pageStatus = false
            Dialog.alert({
                message: '页面缺少参数'
            })
        }
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'getLocation',
            'getAddress',
            'saveAddressInfo',
        ]),
        doBgColor (type) {
            const app = document.querySelector('#app')
            const mainBox = app.querySelector('.mainBox')
            if (type === 'del') {
                app.removeAttribute('style')
                mainBox.setAttribute('style', `padding-top: ${(this.isWeixin || this.isApp) ? '0px' : '1.173333rem'}`)
            } else {
                app.setAttribute('style', `background-color: ${this.page_bg_color || '#b72021'}`)
                if ((!this.isWeixin && !this.isApp) && (isAndroid() || isIOS())) {
                    mainBox.setAttribute('style', `margin-top: 1.173333rem;padding-top: 0`)
                }
            }
        },
        wxShareConfig () {
            wxShare(Object.assign(this.share, {link: location.href}))
        },
        initLocation () {
            const addressInfo = getLocalConfig('AddressInfo')
            if (addressInfo && !_.isEmpty(addressInfo)) {
                this.address = addressInfo.name
                const position = _.pick(addressInfo, ['longitude', 'latitude'])
                Object.assign(this.position, position)
                this.isPosition = true
            }
        },
        getAddressData () {
            if (!this.address) {
                this.getAddress(Object.values(this.position))
                    .then(res => {
                        const param = {
                            longitude: this.position.longitude,
                            latitude: this.position.latitude,
                            province: res.addressComponents.province,
                            city: res.addressComponents.city,
                            district: res.addressComponents.district,
                            name: res.address || '',
                            formattedAddress: res.address
                        }
                        this.address = param.name
                        this.setAddressInfo(param)
                    })
            }
        },
        setAddressInfo (params, successStatus = true) {
            const obj = {
                longitude: params.longitude,
                latitude: params.latitude,
                province: '广东省',
                city: '广州市',
                district: '白云区',
                name: '广州-同和地铁站',
                formattedAddress: '广州-同和地铁站'
            }
            if (!successStatus) {
                this.address = '广州-同和地铁站'
            } else {
                Object.assign(obj, params)
            }
            this.saveAddressInfo(obj)
        },
        getPromotionData () {
            this.showLoading()
            getPromotionInfo({
                topic_id: this.detailParams.topic_id,
                // sstore_id: 0,
                longitude: this.position.longitude,
                latitude: this.position.latitude
            })
                .then(res => {
                    Object.assign(this, res)
                    this.$emit('setHeader', {
                        title: res.share.title,
                        showHeader: true,
                        showLeft: true,
                    })
                    this.isWeixin && this.wxShareConfig()
                    this.page_bg_color && this.doBgColor()
                    this.hideLoading()
                })
                .catch(err => {
                    this.hideLoading()
                    if (err.errcode === 9110) {
                        this.pageStatus = false
                        this.$router.push({
                            path: '/pageNotFound',
                            query: {}
                        })
                    }
                    this.setAppClass({
                        isAppend: true,
                        className: 'bgGreyColor'
                    })
                })
        },
        infinite () {
            // this.getGoodsListInfo()
            this.getFloorData()
        },
        getGoodsListInfo () {
            getPromotionGoodsInfo({
                topic_type: 1, // 类型，0：常规，1：自定义
                topic_id: this.detailParams.topic_id || '',
                store_id: this.detailParams.store_id || '',
                page: this.page_no,
                pagesize: this.page_size,
                floor_type: 2, // 商品类型 1主推商品 2楼层商品
            })
                .then(data => {
                    this.goodsList.push(...data)
                    if (data.length < this.page_size) {
                        this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                    } else {
                        this.page_no += 1
                        this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        async getFloorData () {
            try {
                const { floor_infos } = await getPromotionFloorInfo({
                    topic_type: 1,
                    topic_id: this.detailParams.topic_id || '',
                    store_id: this.detailParams.store_id || '',
                    is_specially_activity: 0, // 0或者不传为楼层商品，1特惠活动
                    page: this.pageNo, // 获取特惠活动不传
                    pagesize: this.pageSize // 获取特惠活动不传
                })
                _.map(floor_infos, item => {
                    if (item.shop_info.length > 6) {
                        item.shop_info = item.shop_info.slice(0, 6)
                        item.showMore = true
                    } else {
                        item.showMore = false
                    }
                })
                this.floor_infos.push(...floor_infos)
                if (floor_infos.length < this.pageSize) {
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                } else {
                    this.pageNo += 1
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                }
            } catch (err) {
                this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                console.log(err)
            }
        },
        headerCallback (params) {
            const status = this.hasLocation()
            if (status) {
                const { type, cb } = params
                const query = {
                    topic_id: this.detailParams.topic_id
                }
                if (type === 'jump') {
                    Object.assign(query, {title: this.floor.floor_goods_title, topic_id: this.detailParams.topic_id, page_code: 'customDetail'})
                } else if (type === 'selectAddress') {
                    Object.assign(query, {city: this.address})
                    delete query.topic_id
                }
                cb(query)
            }
        },
        goodsCallback (params) {
            const status = this.hasLocation()
            status && params.cb(Object.assign(params.value, {topic_id: this.detailParams.topic_id, topic_type: 1, page_code: 'customDetail'}))
        },
        mapCallback (params) {
            const status = this.hasLocation()
            if (status) {
                const { type, value, cb } = params
                if (type === 'list' || type === 'map') {
                    Object.assign(value, {
                        ...this.position,
                        topic_id: this.detailParams.topic_id,
                        topic_type: 1,
                        isPosition: true,
                        page_code: 'customDetail'
                    })
                    cb(value)
                } else if (type === 'goodsList') {
                    Object.assign(value, {
                        topic_id: this.detailParams.topic_id,
                        topic_type: 1,
                        page_code: 'customDetail'
                    })
                    cb(value)
                } else {
                    cb()
                }
            }
        },
        goMore (floorId, title) {
            this.$router.push({
                path: '/customGoodsList',
                query: {
                    topic_id: this.detailParams.topic_id,
                    page_code: 'customDetail',
                    title,
                    floor_id: floorId
                }
            })
        },
        hasLocation () {
            if (Object.values(this.position).every(item => !!item)) {
                return true
            } else {
                this.getMyLocation()
                return false
            }
        },
        getMyLocation () {
            this.showLoading()
            const options = { timeout: 3000, from: 'noTips' }
            // var geolocation = new qq.maps.Geolocation('3PDBZ-UERCW-ZBORT-OIRZ4-NKWD6-ZMBI6', 'fc')
            // geolocation.getLocation(this.showPosition, this.showErr, options)
            this.getLocation(options)
                .then(this.showPosition)
                .catch(this.showErr)
                .finally(() => {
                    this.hideLoading()
                    this.isPosition = true
                })
        },
        /* 获取位置信息成功 */
        showPosition (position) {
            this.position.longitude = position.lng
            this.position.latitude = position.lat
        },
        /* 获取位置信息失败，定位失败再请求定位，测试使用 */
        showErr () {
            // 定位同和地铁站
            this.position.longitude = 113.332926
            this.position.latitude = 23.202723
            this.setAddressInfo({
                longitude: 113.332926,
                latitude: 23.202723,
                name: '广州-同和地铁站',
                address: '广州-同和地铁站'
            }, false)
        },
    },
    destroyed () {

    },
}
